export function hasObjectKey(k: string, obj: Object): k is keyof typeof obj {
  return k in obj;
}
